import { CheckCircle } from 'lucide-react'
// import { useState } from 'react'

import { Reveal } from '@/components/ui/Reveal'

const perks = [
  'Free to list — no setup cost',
  '0% commission for the first 90 days',
  'Dashboard ready the same day',
  'Dedicated onboarding support',
]

export function OwnerCTA() {
  // const [form, setForm] = useState({ email: '', name: '', phone: '', turf: '' })
  // const [submitted, setSubmitted] = useState(false)
  // const [loading, setLoading] = useState(false)

  // function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
  //   setForm((f) => ({ ...f, [e.target.name]: e.target.value }))
  // }

  // async function handleSubmit(e: React.FormEvent) {
  //   e.preventDefault()
  //   setLoading(true)
  //   // TODO: wire to Supabase insert
  //   await new Promise((r) => setTimeout(r, 1000))
  //   setLoading(false)
  //   setSubmitted(true)
  // }

  return (
    <section
      className="py-20"
      id="owners"
      style={{ background: 'var(--bg2)', borderTop: '1px solid var(--lime-line)' }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Left */}
        <div>
          <Reveal>
            <div
              className="inline-block text-[0.68rem] font-bold tracking-widest uppercase px-3 py-1.5 rounded-full mb-4"
              style={{ background: 'var(--lime-dim)', color: 'var(--lime)' }}
            >
              For Turf Owners
            </div>
          </Reveal>
          <Reveal delay={0.05}>
            <h2
              className="font-display font-bold leading-[1.1] tracking-tight mb-3"
              style={{
                color: 'var(--text)',
                fontSize: 'clamp(2rem,3.5vw,2.8rem)',
                letterSpacing: '-.5px',
              }}
            >
              Grow your turf business
              <br />
              with less effort.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p
              className="text-[0.9rem] font-light leading-[1.75] max-w-130 mb-8"
              style={{ color: 'var(--muted)' }}
            >
              No more WhatsApp chaos, missed calls, or manual entries. Get your turf listed in under
              10 minutes and start accepting online bookings immediately. Zero commission for your
              first 90 days.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="flex flex-col gap-3">
              {perks.map((p) => (
                <div
                  className="flex items-center gap-2.5 text-[0.82rem]"
                  key={p}
                  style={{ color: 'var(--muted)' }}
                >
                  <CheckCircle size={16} style={{ color: 'var(--lime)', flexShrink: 0 }} />
                  {p}
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        {/* Right — Form
        <Reveal delay={0.1}>
          <div
            className="rounded-2xl p-8"
            style={{ background: 'var(--bg)', border: '1px solid var(--lime-line)' }}
          >
            {submitted ? (
              <div className="text-center py-8">
                <CheckCircle className="mx-auto mb-4" size={48} style={{ color: 'var(--lime)' }} />
                <div
                  className="font-display font-bold text-xl mb-2"
                  style={{ color: 'var(--text)' }}
                >
                  You're on the list!
                </div>
                <p className="text-[0.85rem] font-light" style={{ color: 'var(--muted)' }}>
                  We'll call you within 24 hours to get your turf live on TurfChale.
                </p>
              </div>
            ) : (
              <>
                <div
                  className="font-display font-semibold text-[1.05rem] mb-5"
                  style={{ color: 'var(--text)' }}
                >
                  Get your turf listed →
                </div>
                <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
                  {[
                    { name: 'name', placeholder: 'Your name', type: 'text' },
                    { name: 'turf', placeholder: 'Turf name & city', type: 'text' },
                    { name: 'phone', placeholder: 'WhatsApp number', type: 'tel' },
                    { name: 'email', placeholder: 'Email address', type: 'email' },
                  ].map((field) => (
                    <input
                      className="w-full rounded-xl px-4 py-3 text-[0.875rem] outline-none transition-colors duration-200"
                      key={field.name}
                      name={field.name}
                      onBlur={(e) => (e.currentTarget.style.borderColor = 'var(--lime-line)')}
                      onChange={handleChange}
                      onFocus={(e) => (e.currentTarget.style.borderColor = 'rgba(184,236,60,.5)')}
                      placeholder={field.placeholder}
                      required
                      style={{
                        background: 'var(--bg3)',
                        border: '1px solid var(--lime-line)',
                        color: 'var(--text)',
                      }}
                      type={field.type}
                      value={form[field.name as keyof typeof form]}
                    />
                  ))}
                  <button
                    className="w-full py-3 rounded-xl text-[0.9rem] font-bold transition-opacity duration-200 mt-1"
                    disabled={loading}
                    style={{
                      background: 'var(--lime)',
                      border: 'none',
                      color: 'var(--bg)',
                      opacity: loading ? 0.7 : 1,
                    }}
                    type="submit"
                  >
                    {loading ? 'Submitting...' : "Submit — We'll Call You Today"}
                  </button>
                  <p className="text-center text-[0.7rem]" style={{ color: 'var(--text-dim)' }}>
                    Free to start · No credit card required
                  </p>
                </form>
              </>
            )}
          </div>
        </Reveal> */}
      </div>
    </section>
  )
}
